import React from 'react';

/**
 * AgentOps Overview Help Content
 */
const AgentOpsOverviewHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          AgentOps Overview
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The AgentOps Overview provides a comprehensive dashboard for monitoring your AI agents. Track agent executions, tool usage, performance metrics, and incidents from a single view.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Key Metrics
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Total Runs</span>: Number of agent executions</p>
          <p>&#8226; <span className="font-medium">Success Rate</span>: Percentage of successful completions</p>
          <p>&#8226; <span className="font-medium">Avg Duration</span>: Mean execution time per run</p>
          <p>&#8226; <span className="font-medium">Tool Calls</span>: Total tool invocations</p>
          <p>&#8226; <span className="font-medium">Active Incidents</span>: Unresolved issues</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Dashboard Widgets
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Customize your dashboard with relevant widgets:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; Agent execution timeline</p>
          <p>&#8226; Tool usage breakdown</p>
          <p>&#8226; Error rate trends</p>
          <p>&#8226; Resource consumption charts</p>
          <p>&#8226; Recent incidents feed</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Quick Navigation
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Use the tabs above to explore specific areas: <span className="font-medium">Runs</span> for agent executions, <span className="font-medium">Tools</span> for tool analytics, <span className="font-medium">APM</span> for performance monitoring, and more.
        </p>
      </div>

    </>
  );
};

export default AgentOpsOverviewHelp;
